// Global DEBUG variable set by rspack DefinePlugin
declare const DEBUG: boolean;

export interface SessionTimeoutOption {
	value: string;
	label: string;
}

export const sessionTimeoutOptions: SessionTimeoutOption[] = [
	{ value: "30", label: "30 Minutes" },
	{ value: "60", label: "1 Hour" },
	{ value: "120", label: "2 Hours" },
	{ value: "360", label: "6 Hours" },
	{ value: "720", label: "12 Hours" },
	{ value: "1440", label: "24 Hours" },
];

// Add debug options for development environment
const debugOptions: SessionTimeoutOption[] = [
	{ value: "1", label: "1 Minute" },
	{ value: "2", label: "2 Minutes" },
	{ value: "3", label: "3 Minutes" },
	...sessionTimeoutOptions,
];

export interface SessionTimeoutRedirectOption {
	value: string;
	label: string;
}

export const sessionTimeoutRedirectOptions: SessionTimeoutRedirectOption[] = [
	{ value: "off", label: "Off" },
	{ value: "on", label: "On" },
];

export const getSessionTimeoutOptions = (): SessionTimeoutOption[] => {
	// Check if we're in debug mode (DEBUG is set by rspack DefinePlugin)
	const isDebug = typeof DEBUG !== "undefined" && DEBUG;
	return isDebug ? debugOptions : sessionTimeoutOptions;
};
